import { handleServiceError } from '../utils/errorHandler';
import type { StudentHistoryMessage, StudentHistoryPayload, StudentHistoryStudent } from '../types/studentHistory';
import { requestEdgeFunction } from './edgeFunctionClient';

class StudentHistoryServiceClass {
  async getStudentHistory(studentId: number, pageSize: number = 200): Promise<StudentHistoryPayload> {
    const safePageSize = Math.max(1, Math.min(pageSize, 500));
    const response = await requestEdgeFunction<{ data?: StudentHistoryPayload }>('get-student-history', {
      method: 'GET',
      query: {
        studentId,
        notesPageSize: safePageSize,
      },
    }).catch((error) => {
      handleServiceError(error, 'buscar histórico da aluna');
      throw error;
    });

    const data = response.data;
    return {
      student: (data?.student ?? null) as StudentHistoryStudent | null,
      messages: (data?.messages ?? []) as StudentHistoryMessage[],
      pagination: data?.pagination ?? {
        hasNextPage: false,
        cursor: null,
      },
    };
  }
}

export const StudentHistoryService = new StudentHistoryServiceClass();
